const lbMap = angular.module('app.lbMap', []);

lbMap.controller('lbMapController', require('./lbMapController'));
lbMap.directive('lbMap', require('./lbMapDirective'));

export default lbMap;



// WEBPACK FOOTER //
// ./src/components/lbMap/index.js